import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';
import Header from './ContactListHeader';

const ContactList = ({ className, header, count, title, children, ...props }) => {
  const cn = useClassNames(() => className, [className]);

  return (
    <section data-component="ContactList" className={cn} {...props}>
      {(header || title) && <header>{header || <Header count={count}>{title}</Header>}</header>}
      <ul>{children}</ul>
    </section>
  );
};

ContactList.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  header: PropTypes.node,
  count: PropTypes.number,
  title: PropTypes.string,
  children: PropTypes.node,
};

ContactList.defaultProps = {
  className: '',
  header: null,
};

export default ContactList;
